/**
 * Which edge of its trigger the connectors panel hangs from.
 *
 * The CSS places the panel with logical insets: from the trigger's
 * inline-start edge (growing toward inline-end), or — with `--end` — from its
 * inline-end edge (growing toward inline-start). The room on each side is
 * therefore measured in that same frame: in Hebrew inline-start is the RIGHT
 * edge, so a physical left/right comparison would pick the wrong side.
 */
export interface TriggerBox {
  left: number;
  right: number;
}

/** The panel's width as the CSS sizes it: min(360px, 100vw - 32px). */
export function panelWidthFor(viewportWidth: number): number {
  return Math.min(360, viewportWidth - 32);
}

/** True when the panel should hang from the trigger's inline-end edge. */
export function hangFromInlineEnd(trigger: TriggerBox, viewportWidth: number, rtl: boolean): boolean {
  // Room the panel has when hung from inline-start (it grows toward inline-end)…
  const fromStart = rtl ? trigger.right : viewportWidth - trigger.left;
  // …and when hung from inline-end (it grows toward inline-start).
  const fromEnd = rtl ? viewportWidth - trigger.left : trigger.right;
  // The design's default is inline-start; leave it only when the panel would
  // not fit that way and the other side has more room.
  return fromStart < panelWidthFor(viewportWidth) + 16 && fromEnd > fromStart;
}
